/**
 * User: herbert
 * Date: 12.02.16
 * Time: 11:20
 */

import React from 'react';
import Reflux from 'reflux';

import finishStore from '../stores/finish-store.js';

import finishConfig from '../../../config-finish.js';
import T from '../../../nls/translate.js';

import FinishItem from './finish-item.jsx';

export default React.createClass({
	mixins: [
		Reflux.connect(finishStore, 'data') // this.state.data entspricht parameter von trigger() bei output: des stores, hier: ein Array mit StepPart-Elementen
	],
	render: function() {
		// INFO currently applied finish does not get marked in list
		const options = finishConfig.map(
		                    color => <FinishItem key={color.id} color={color} apply={true} />
		);
		const c = this.state.data ? this.state.data.selected : finishConfig[0];
		return (<div className="slx-finish">
			<span className="slx-finish-instructions">{T.current.FINISH.INFO}</span>
			<div className="slx-finish-colors">
				{options}
			</div>

			<div className="slx-finish__colorbox1 slx-finish__bigcolorbox">
				<header>{T.current.FINISH.HEADER}</header>
				<div className="slx-finish__colorbox-infos">

					<span className="slx-finish__colorbox-infos__code">{c.code}</span><br />
					<span className="slx-finish__colorbox-infos__name">{T.current.FINISH[c.id]}</span>
				</div>

				<div className={'slx-finish__colorbox-infos__color slx-finish__' + c.id} />
			</div>

			{/*<button className="slx-finish-close" onClick={finishActions.apply} >{ T.current.APPLY }</button> // WARNING this need stepActions.switchSubStep enabled again in finishStore.onApply */}

		</div>);
	},
});
